<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" :visibleStore="false">
                    <template v-slot:action="{ item }">
                        <v-btn class="mr-2" depressed small @click.stop="" color="info" :to="{ name: 'WorkerDailyReportApproval', params: { management_user: item.management_user, user_id: item.user_id, worker_date: item.worker_date } }">閲覧</v-btn>
                    </template>
                </custom-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import WorkerDailyReportComformApi from "@/api/worker-daily-report-comform-api";
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  export default {
    name: "WorkerDailyReportComform",
    components: {
      CustomDataTable
    },
    data: () => ({
        // 作業日報一覧テーブル
        loading: false,
        tableName: "作業日報確認",
        headers: [
            { text: "作業者名", value: "user_name" },
            { text: "作業日", value: "worker_date" },
            { text: "アクション", value: "action" }
        ],
        items: [],
        test: null
    }),
    created() {
      this.initialize();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize() {
        this.isLoading();
        this.WorkerDailyReportComformApi = new WorkerDailyReportComformApi();
        const promise = this.WorkerDailyReportComformApi.list();
        promise.then(response => {
          this.items = response.data.body.worker_daily_report_comform_list
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError){
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "Dashboard" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    }
  };
</script>
